import React from 'react';
import IconLabel from '../IconLabel/IconLabel';
import {
  Occasion as OccasionModel,
  OccasionType,
} from '../../../types/__generated__';
import { useBasePageQuery } from '../../hooks';
import { useTranslation } from 'react-i18next';
import { bellIcon } from '@justgiving/icons';

export const Occasion: React.FC = () => {
  const { data } = useBasePageQuery();
  const { t } = useTranslation('common', { useSuspense: false });

  if (!data?.page?.occasion) {
    return null;
  }

  const label = renderOccasion(data?.page?.occasion);

  if (!label) {
    return null;
  }

  function renderOccasion(occasion: OccasionModel): string | null {
    const date = occasion.date
      ? new Date(occasion.date).getTime().toString()
      : null;

    switch (occasion.type) {
      case OccasionType.Birthday: {
        const name = occasion.names?.[0];

        if (!name) {
          return null;
        }

        if (occasion.date) {
          return t('occasion.birthday.withDateLabel', {
            name,
            date,
          });
        } else {
          return t('occasion.birthday.withoutDateLabel', { name });
        }
      }
      case OccasionType.InMemory: {
        const name = occasion.names?.[0];

        if (!name) {
          return null;
        }

        return t('occasion.inMemory.label', { name });
      }
      case OccasionType.Wedding: {
        const name1 = occasion.names?.[0];
        const name2 = occasion.names?.[1];

        if (!name1 || !name2) {
          return null;
        }

        if (occasion.date) {
          return t('occasion.wedding.withDateLabel', {
            name1,
            name2,
            date,
          });
        } else {
          return t('occasion.wedding.withoutDateLabel', { name1, name2 });
        }
      }
      case OccasionType.Other: {
        const description = occasion.description;

        if (!description) {
          return null;
        }

        if (occasion.date) {
          return t('occasion.other.withDateLabel', {
            description,
            date,
          });
        } else {
          return t('occasion.other.withoutDateLabel', { description });
        }
      }
      default:
        return null;
    }
  }

  return <IconLabel icon={bellIcon} label={label} />;
};
